import * as React from "react";
import MuiGrid, { GridProps as MuiGridProps } from '@material-ui/core/Grid';

export { GridSize, GridDirection, GridContentAlignment, GridItemsAlignment, GridJustification, GridSpacing, GridWrap, GridClassKey } from '@material-ui/core/Grid';

export interface GridProps extends MuiGridProps {
}

class Grid extends React.PureComponent<GridProps> {
    render() {
        return <MuiGrid {...this.props}>
            {this.props.children}
        </MuiGrid>;
    }
}

export default Grid;